import { baseUrl } from "../http/axiosInstance";


export function urlWithProtocolId(protocolId: number)
{
  return location.href
    .replace(/protocol(\/\d+)?/i, "protocol/" + protocolId)
    .split(process.env.ENV === "dev" ? baseUrl.replace(process.env.PORT || "3001", "3000") : baseUrl)[1];
}
